import {useEffect, useState} from 'react';


const Textarea = (options) => {
    const [value, setValue] = useState(options && options.value ? options.value : '');

    const name = options && options.name != undefined ? options.name : '';
    const className = options && options.className != undefined ? options.className : 'form-control input-sm'
    const placeholder = options && options.placeholder != undefined ? options.placeholder : 'Type something...'
    const counter = options && options.counter != undefined ? options.counter : false
    const [length, setLength] = useState(value.length);


    useEffect(() => {
    }, [value])


    const handleChange = (event) => {
        let inputVal = event.target.value;

        if (typeof options.onChange == "function") {
            const onChangeValue = options.onChange(event)
            if(onChangeValue != undefined){
                inputVal = onChangeValue
            }
        }

        setValue(inputVal);
        setLength(event.target.value.length)
    }

    const handleBlur = () => {
        if (typeof options.onBlur == "function") {
            options.onBlur(value)
        }
    }


    return (
        <div className="Textarea input-container">
            <textarea
                rows={6}
                name={name}
                onBlur={handleBlur}
                defaultValue={value}
                className={className}
                onChange={handleChange}
                placeholder={placeholder}
            />
            {counter && <span className="counter">{length}</span>}
        </div>
    )
}

export default Textarea;